/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Форма успешного восстановления пароля
   */
  app.PasswordResetSuccessFormView = app.FormView.extend({
    el: '#password-reset-success-form',
    formName: 'password-reset-success',
    formElement: '.field_input',
    events: {
      'click .button_blue': 'submit',
      'click .js-popup-close': 'goToLoginForm',
      'click .to_login_form': 'goToLoginForm'
    },
    
    run: function () {
      app.FormView.prototype.run.apply(this);
      this.$buttonBlue = this.$('.button_blue');
      this.$example = this.$('.example');
    },
    
    /**
     * Возбуждает событие для перехода к форме авторизации
     */
    goToLoginForm: function () {
      this.trigger('go-to-login-form');
    },
    
    submit: function (e) {
      e.preventDefault();
      this.$buttonBlue.addClass('disabled');
      this.$buttonBlue.prop('disabled', true);
      this.model.save(this.attributes, {
        success: this.success.bind(this),
        error: this.error.bind(this),
      });
    },
  
    /**
     * Отрисовывает шаблон успешного восстановления по email
     * @param {object} model
     */
    render: function (model) {
      var template;
      this.$buttonBlue.addClass('disabled');
      this.$buttonBlue.prop('disabled', true);
      this.$example.show();
      this.attributes = model.toJSON();
      template = this.model.get('type') === 'email'
        ? '#mailRestoreText'
        : '#phoneRestoreText';
      this.template = app.helpers.TemplateHelper.getTemplate(template);
      this.$('.restore-text').html(this.template({model: this.model}));
      this.$el.show();
      this.setRequestTimeout();
    },
  
    /**
     * Обработчик успешного сохранения формы
     * @param successEvent модель
     */
    success: function (successEvent) {
      app.FormView.prototype.success.apply(this, successEvent);
      this.$example.show();
      this.setRequestTimeout();
    },
  
    /**
     * Таймаут для повторного запроса и обратный отсчет
     */
    setRequestTimeout: function () {
      var that = this,
        endTime,
        $elemTimer = this.$('#againTimer'),
        cooldown;
      if(that.$buttonBlue.hasClass('disabled')) {
        $elemTimer.text(app.requestFormCooldown);
        endTime = app.requestFormCooldown;
        cooldown = setInterval(function(){
          endTime = --endTime;
          $elemTimer.text(endTime);
          if (endTime === 0){
            clearInterval(cooldown);
          }
        }, 1000);
      }
      setTimeout(function () {
        that.$buttonBlue.removeClass('disabled');
        that.$buttonBlue.prop('disabled', false);
        that.$example.hide();
      }, app.requestFormCooldown * 1000);
    },
    
    /**
     * Заполнение ошибок
     * @param {arr} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      var that = this;
      var $errorSpan;
      
      errors.forEach(function (error) {
        $errorSpan = $('#' + that.formName + '-' + error.field + '-error');
        $errorSpan.text(error.message);
        $errorSpan.show();
        $('#' + that.formName + '-' + error.field).parent().addClass('invalid');
      });
    },
    
    /**
     * Очистка ошибок
     */
    clearErrors: function () {
      this.$fields.each(function () {
        $(this).parent().removeClass('invalid');
      });
      this.$el.find('.invalid_message').text('').hide();
    }
  });
})(jQuery);

}.call(window));